import { useState, useCallback } from 'react';

/**
 * Hook for managing bulk selection + delete in list pages.
 * Usage:
 *   const { selected, toggleSelect, selectAll, clearSelection, isSelected, selectedCount } = useBulkSelect();
 */
export function useBulkSelect() {
  const [selected, setSelected] = useState(new Set());

  const toggleSelect = useCallback((id) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const selectAll = useCallback((ids) => {
    setSelected(new Set(ids));
  }, []);

  const clearSelection = useCallback(() => {
    setSelected(new Set());
  }, []);

  const isSelected = useCallback((id) => selected.has(id), [selected]);

  return {
    selected,
    toggleSelect,
    selectAll,
    clearSelection,
    isSelected,
    selectedCount: selected.size,
    selectedIds: Array.from(selected),
  };
}
